import { FC, useState } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { HTHItemCard } from './commons/HTHItemCard';
import { HTHObservationsForm } from './HTHSectionFaceObservationsForm';
import { typeObservation, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetCurrentUser } from 'src/custom-hooks';

type propsType = {
    closeShowAddFormHandler: () => void;
    currentFace: typeHTHFace;
    observation: typeObservation;
    territoryNumber: typeTerritoryNumber;
};

export const HTHObservationsItem: FC<propsType> = ({ closeShowAddFormHandler, currentFace, observation, territoryNumber }) => {
    const [showForm, setShowForm] = useState(false);
    const config = useGetConfig();
    const dispatch = useDispatch();
    const user = useGetCurrentUser();

    const editHandler = (): void => {
        closeShowAddFormHandler();
        setShowForm(true);
    }

    const deleteHandler = (): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: '¿Eliminar Observación?',
            message: `Se va a eliminar esta observación de la Manzana ${generalHthHelper.MaskTheBlock(currentFace.block, config.isUsingLettersForBlocks)}, cara ${currentFace.street}: "${observation.text}"`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await houseToHouseServices.DeleteObservation(territoryNumber, currentFace.block, currentFace.face, observation.id);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
            }
        }));
    }

    const closeShowFormHandler = (): void => setShowForm(false);

    return (
        <>
        <HTHItemCard
            creatorId={observation.creatorId}
            date={observation.date}
            deleteHandler={deleteHandler}
            editHandler={editHandler}
            text={observation.text}
        />
        {/* edit observation form */}
        {(user.isHthAdmin || observation.creatorId === user.id) && showForm &&
            <HTHObservationsForm
                closeShowFormHandler={closeShowFormHandler}
                currentFace={currentFace}
                territoryNumber={territoryNumber}
                editText={observation.text}
                idEdit={observation.id}
            />
        }
        </>
    );
}
